import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ContractService } from '../services/contract.service';
import { TicketService } from '../services/ticket.service';
import { Contract } from '../models/contract.model';
import { Ticket } from '../models/ticket.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'account',
  templateUrl: '../views/core/account.html',
  providers: [ContractService, TicketService]
})
export class AccountComponent{
  public title: string;
  public contracts: any[];
  public tickets: Ticket[];
  public message: any;
  public contract_id:number;
  public countTicket:number;
  public sumTicket:number;
  public totaldebt:number;
  public wait:boolean;
  public contractPrivilege:number;
  public privileges:Privileges[];
  public linkToPdf:string;
  public progress:number;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private contractService: ContractService,
    public sharedVariables: VariableService,
    private ticketService: TicketService
  )
  {
      this.title = "Account module";
      this.sumTicket = 0;
      this.countTicket = 0;
      this.totaldebt = 0;
      this.wait = true;
      this.contractPrivilege = null;
      this.linkToPdf = null;
      this.progress = 0;
  }

  /*ngOnInit()
  {

    console.log(this.sharedVariables);
    if(this.sharedVariables.validSession()){
      this.getContractInformation();
    }else
      this.title = "Error, Sesión no iniciada";
  }*/
  ngOnInit()
  {

    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getContractInformation();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getContractInformation()
  {
    this._route.params.forEach((params: Params)=>{
      let id = params['id'];
      this.contract_id = id;
      console.log(this.contract_id);
      this.getContract(this.contract_id);
      this.getAllTickets(this.contract_id);
      setTimeout(()=> {
                        this.ticketInformation();
                      },this.sharedVariables.timeToLoad);
      setTimeout(()=> {
                        this.totaldebt = this.contracts[0].price - (parseFloat(this.contracts[0].initial_investment+"") + this.sumTicket);
                        this.progress = (((this.contracts[0].price - this.totaldebt) * 100) / this.contracts[0].price);
                      },this.sharedVariables.timeToLoad);
    });
  }
  generateContract(service_id:number,id_contract:number,customer_id:number,report_name:string)
  {
    this.contractService.generateContract(service_id,id_contract,customer_id,report_name).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          setTimeout(()=> {
                           this.linkToPdf = result.data;
                           window.open(this.linkToPdf,'_blank');
                           console.log("link para el pdf",this.linkToPdf);
                         },this.sharedVariables.timeToReport);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getContract(id:number)
  {
    this.contractService.getContract(id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.contracts = result.data;
          console.log("VARIABLE CONTRACT",this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getAllTickets(id:number)
  {
    this.ticketService.getTicket(id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  validSession()
  {
    console.log(GLOBAL.sessionInfo.login);
    if(GLOBAL.sessionInfo.login)
      return true;
    else
      return false;
  }
  ticketInformation()
  {
    if(this.tickets != null)
    {
      for (let i = 0; i < this.tickets.length; i++) {

          this.sumTicket += parseFloat(this.tickets[i].total+"");
          this.countTicket ++;
          console.log(this.tickets[i].total);
      }
    }
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",this.contractPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/account.component.ts